/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { IUser } from '../../types/user/IUser';

export enum AuthActions {
  AUTHORIZE_USER_BY_TOKEN_WATCHER = 'AUTHORIZE_USER_BY_TOKEN_WATCHER',
  AUTH_SET_USER = 'AUTH_SET_USER',
  AUTH_CHECK_START = 'AUTH_CHECK_START',
  AUTH_CHECK_AUTHORIZED = 'AUTH_CHECK_AUTHORIZED',
  AUTH_CHECK_NOT_AUTHORIZED = 'AUTH_CHECK_NOT_AUTHORIZED',
  AUTH_LOGOUT_WATCHER = 'AUTH_LOGOUT_WATCHER',
  AUTH_LOGOUT = 'AUTH_LOGOUT',
  AUTH_LOGIN = 'AUTH_LOGIN',
  AUTH_REFRESH_USER_WATCHER = 'AUTH_REFRESH_USER_WATCHER',

  AUTH_CLEANER = 'AUTH_CLEANER',

  AUTH_REFRESH_START = 'AUTH_REFRESH_START',
  AUTH_REFRESH_COMPLETED = 'AUTH_REFRESH_COMPLETED',
}

export type AuthorizeUserByTokenAction = {
  type: AuthActions.AUTHORIZE_USER_BY_TOKEN_WATCHER;
  payload: { token: string; expires: Date };
};

export type AuthSetUserAction = {
  type: AuthActions.AUTH_SET_USER;
  payload: { user: IUser };
};

export type AuthCheckStartAction = {
  type: AuthActions.AUTH_CHECK_START;
};

export type AuthCheckAuthorizedAction = {
  type: AuthActions.AUTH_CHECK_AUTHORIZED;
  payload: { user: IUser };
};

export type AuthCheckNotAuthorizedAction = {
  type: AuthActions.AUTH_CHECK_NOT_AUTHORIZED;
  payload: { errorMessage?: string };
};

export type AuthLogoutWatcherAction = {
  type: AuthActions.AUTH_LOGOUT_WATCHER;
  payload: { isBySystem?: boolean };
};

export type AuthLogoutAction = {
  type: AuthActions.AUTH_LOGOUT;
  payload: { isBySystem?: boolean };
};

export type AuthLoginAction = {
  type: AuthActions.AUTH_LOGIN;
  payload: { user: IUser };
};

export type AuthRefreshUserWatcherAction = {
  type: AuthActions.AUTH_REFRESH_USER_WATCHER;
};

export type AuthRefreshUserStartAction = {
  type: AuthActions.AUTH_REFRESH_START;
};

export type AuthRefreshUserCompleterAction = {
  type: AuthActions.AUTH_REFRESH_COMPLETED;
};

export type SignUpForm = {
  email: string;
  firstName: string;
  lastName: string;
};

export type AuthState = {
  isFetching: boolean;
  isRefreshing: boolean;
  errorMessage?: string;
  user?: IUser;
  isAuthenticated: boolean;
  isAuthCheckCompleted: boolean;
  form: SignUpForm;
};

type AuthCleaner = {
  type: AuthActions.AUTH_CLEANER;
};

export type AuthActionTypes =
  | AuthorizeUserByTokenAction
  | AuthSetUserAction
  | AuthCheckStartAction
  | AuthCheckAuthorizedAction
  | AuthCheckNotAuthorizedAction
  | AuthLogoutAction
  | AuthRefreshUserWatcherAction
  | AuthLogoutWatcherAction
  | AuthLoginAction
  | AuthCleaner
  | AuthRefreshUserStartAction
  | AuthRefreshUserCompleterAction;
